import React, {Component} from 'react';
import {connect} from "react-redux";

import HealthMenu from "../HealthMenu";
import {getHealth} from "../../containers/App/actionsAsync";

import './css/header.css';

class Header extends Component {

    static propTypes = {
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {getHealth, healthServiceName, healthServices} = this.props;

        if (!healthServices[healthServiceName]?.healthArray) {
            getHealth(healthServiceName);
        }
    }

    render() {
        const {headerElement, title, status, healthServiceName, healthServices} = this.props;

        const renderTitle = headerElement ? headerElement : title;
        const health = healthServices[healthServiceName]?.healthArray;

        return (
            <div className="header__container">
                <div className="header__title">
                    <div className="header__title-name-container">
                        <div className="header__title-name">
                            <div className="title">
                                {renderTitle}
                                <HealthMenu status={status} health={health} popoverPosition="left"/>
                            </div>
                            <span id="last-update" className="last-update"/>
                        </div>
                        <div id="legend-container"/>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        title: state.app.title,
        headerElement: state.app.headerElement,
        lastUpdate: state.app.lastUpdate,
        status: state.app.status,
        popup: state.app.popup,
        healthServices: state.app.healthServices,
        isMagnetSalesWarning: state.app.isMagnetSalesWarning,
        isMagnetVendorsWarning: state.app.isMagnetVendorsWarning,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getHealth: (service) => dispatch(getHealth(service))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Header)
